import React, { useContext } from "react";
import PayManagement from "./PayManagement";
import { MyContext } from "../../Context/MyContext";
export default function PayManagementWrap(props) {
  const { getSupervisorBalance } = useContext(MyContext);
  return (
    <PayManagement {...props} getSupervisorBalance={getSupervisorBalance} />
  );
}
